<template>
  <v-dialog :value="dialog" width="500" persistent>
    <v-card
      class="d-flex flex-column align-center justify-space-around"
      :class="$vuetify.breakpoint.xsOnly ? 'pa-6' : 'pa-8'"
    >
      <div class="fw500 mb-6 text-center" style="white-space: pre-line" :class="'f20'">
        {{
          chatTranslations.excluded_text +
          '\n(' +
          (this.chatKick && this.chatKick.title) +
          ')'
        }}
      </div>
      <v-card tile flat width="100%" class="d-flex justify-space-around align-center">
        <v-btn type="button" @click="onClose" class="text-none br15" dark color="#277faf" x-large>
          {{ 'OK'}}
        </v-btn>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'ChatModalKicked',
  data() {
    return { dialog: false }
  },
  props: {
    chatTranslations: Object
  },
  watch: {
    chatKick() {
      // console.log('chatKick', this.chatKick)
      this.$nextTick(function () {
        this.dialog = this.chatKick !== null 
      })
    },
  },
  computed: {
    ...mapState('chat', ['chatKick']),
  },
  methods: {
    ...mapMutations('chat', ['SET_chatKick']),
    onClose() {
      this.SET_chatKick(null)
    },
  },
}
</script>
